import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_loose_licenseplate_by_location_nameService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { location_name: string, warehouse_name: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Location?: { Id?: number, IsLoose?: boolean, Name?: string } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.location_name)) {
      $missingRequiredInParams.push('\'location_name\'');
    }
    if (isNil($inParams.warehouse_name)) {
      $missingRequiredInParams.push('\'warehouse_name\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_loose_licenseplate_by_location_name/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      location_name: string, warehouse_name: string    }) {
        if(isNil($inParams.location_name)) {
          return true; 
        }
        if(isNil($inParams.warehouse_name)) {
          return true; 
        }
      return false;
    }
}
